import React, { useState } from 'react';
import Logger from "./Logger";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";

// Initialize Logger
const logger = new Logger(getLoggerBaseURL());

const DeployComponent = () => {
    const [step, setStep] = useState(1); // 1: Initial, 2: OTP Sent, 3: Deployed
    const [otp, setOtp] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const initiateDeployment = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL2}/api/deploy/initiate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (data.success) {
                setStep(2);
                setMessage('OTP has been sent to your email.');
            } else {
                setMessage('Failed to send OTP.');
            }
        } catch (error) {
            logger.log(`Error: ${error}`, "ERROR");
            setMessage('An error occurred while initiating deployment.');
        }
        setLoading(false);
    };

    const verifyOtpAndDeploy = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL2}/api/deploy/verify`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ otp }),
            });

            const data = await response.json();

            if (data.success) {
                setStep(3);
                setMessage('Deployment successfulsss!');
            } else {
                setMessage(data.message || 'OTP verification failed.');
            }
        } catch (error) {
            logger.log(`Error: ${error}`, "ERROR");
            setMessage('An error occurred during deployment.');
        }
        setLoading(false);
    };

    return (
        <div>
            <h2>Deployment Control</h2>
            {step === 1 && (
                <button onClick={initiateDeployment} disabled={loading}>
                    {loading ? 'Sending OTP...' : 'Deploy'}
                </button>
            )}
            {step === 2 && (
                <div>
                    <p>Please enter the OTP sent to your email:</p>
                    <input
                        type="text"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter OTP"
                        autocomplete="off"
                    />
                    <button onClick={verifyOtpAndDeploy} disabled={loading}>
                        {loading ? 'Verifying...' : 'Verify & Deploy'}
                    </button>
                </div>
            )}
            {step === 3 && <p>{message}</p>}
            {message && step !== 3 && <p>{message}</p>}
        </div>
    );
};

export default DeployComponent;
